import "../../index66.css";
import { jsxs as V, jsx as e } from "react/jsx-runtime";
import { _ } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import n from "../ListView/index.js";
const d = "_tab-list-layout_1e7y6_1", m = "_style-variant-nav_1e7y6_6", v = "_style-variant-tab_1e7y6_11", b = "_content_1e7y6_12", u = "_additional-border_1e7y6_16", L = "_style-variant-step_1e7y6_21", N = "_style-variant-pill_1e7y6_27", f = "_style-variant-vertical_1e7y6_39", h = "_style-variant-vertical-compact_1e7y6_51", a = {
  tabListLayout: d,
  styleVariantNav: m,
  styleVariantTab: v,
  content: b,
  additionalBorder: u,
  styleVariantStep: L,
  styleVariantPill: N,
  styleVariantVertical: f,
  styleVariantVerticalCompact: h
};
function B(s) {
  const {
    styleVariant: t,
    colorVariant: i,
    disabled: o,
    elementRef: c,
    children: r,
    className: y,
    spacing: l,
    ...p
  } = s;
  return /* @__PURE__ */ V(
    "div",
    {
      ...p,
      ref: c,
      className: _(
        y,
        a.tabListLayout,
        o && a.disabled,
        i === "primary" && a.colorVariantPrimary,
        i === "secondary" && a.colorVariantSecondary,
        i === "text" && a.colorVariantText,
        t === "tab" && a.styleVariantTab,
        t === "pill" && a.styleVariantPill,
        t === "step" && a.styleVariantStep,
        t === "nav" && a.styleVariantNav,
        t === "vertical" && a.styleVariantVertical,
        t === "vertical-compact" && a.styleVariantVerticalCompact
      ),
      children: [
        /* @__PURE__ */ e("div", { className: a.additionalBorder }),
        t === "vertical" || t === "vertical-compact" ? /* @__PURE__ */ e(
          n,
          {
            layout: "block",
            role: "tablist",
            spacing: t === "vertical" ? "none" : l,
            withSpacingOpticalCorrection: t === "vertical-compact",
            children: r
          }
        ) : /* @__PURE__ */ e(
          n,
          {
            className: a.content,
            spacing: t === "tab" || t === "pill" || t === "step" ? "none" : l,
            role: "tablist",
            withWrap: t === "nav",
            children: r
          }
        ),
        /* @__PURE__ */ e("div", { className: a.additionalBorder })
      ]
    }
  );
}
export {
  B as default
};
